import util from './util.js';

export default class FetchPoller {
	constructor(fn, delay) {
		this.fn = fn;
		this.delay = delay;
		this.abortController = null;
	}

	start(sync) {
		this.stop();
		this.abortController = new AbortController();
		if(sync) return this.step1();
		this.step();
	}

	stop() {
		if(this.abortController)
			this.abortController.abort();
		this.abortController = null;
	}

	step1() {
		return this.fn.call(null, this.abortController.signal)
			.catch(e => console.error('FetchPoller stepping step 1', e))
			.finally(() => { util.setTimeoutPromise(this.delay, this.abortController.signal).then(() => this.step()); })
			;
	}

	async step() {
		try {
			await this.fn.call(null, this.abortController.signal);
		} catch(e) {
			console.error('FetchPoller stepping', e);
		} finally {
			await util.setTimeoutPromise(this.delay, this.abortController.signal);
			this.step(); // call without await
		}
	}
}
